import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { faqs } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="border-y border-line bg-canvasAlt" data-id="element-70" data-mp="1nv1l2blse3ze">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-12" data-id="element-71" data-mp="2blnfh02vbpqx">
        <Reveal data-id="element-72" data-mp="2fmh2zscef2ja">
          <h2 id="faq" className="text-center font-display text-2xl md:text-3xl font-bold uppercase text-ink" data-id="element-73" data-mp="2fkwa075qfrnj">
            Preguntas frecuentes
          </h2>
        </Reveal>

        <div className="mt-6 grid gap-2" data-id="element-74" data-mp="26scfniwh498i">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className="rounded-2xl border border-line bg-surface" data-id="element-75" data-mp="2z9ycfs5g159x" data-mpi={i}>
                <h3 data-id="element-76" data-mp="1voznm9nhvx77">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left" data-id="element-77" data-mp="1vqasydwl9d0f">
                    <span className="text-sm md:text-base font-semibold text-ink" data-id="element-78" data-mp="2fdqle6xlbtra">
                      {faq.q}
                    </span>
                    <ChevronDownIcon size={18} className={`flex-shrink-0 text-accent transition-transform duration-200 ease-soft ${isOpen ? 'rotate-180' : ''}`} data-id="element-79" data-mp="2adm78nk5nb48" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-80" data-mp="u0nv8hnfc2g4">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: EASE
              }} className="overflow-hidden" data-id="element-81" data-mp="p2mazte9hx32">
                      <p className="px-5 pb-4 text-sm leading-relaxed text-ink-muted" data-id="element-82" data-mp="334egnactnihf">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}